module.exports = __webpack_public_path__ + "img/public/SiteIcons/googleIcon.svg?a5158891";